import * as types from '@/store/mutation-types'

const getters = {
  showLoading: state => state.showLoading,
  showTopLoading: state => state.showTopLoading
}

const mutations = {
  [types.SHOW_LOADING](state, value) {
    state.showLoading = value
  },
  [types.SHOW_TOP_LOADING](state, value) {
    state.showTopLoading = value
  }
}

const state = {
  showLoading: false,
  showTopLoading: false
}

export default {
  state,
  getters,
  mutations
}
